import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";

function Form() {
    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.gci_company_id) {
        hiddenValues.gci_company_id = profileFilter.gci_company_id
    }

    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/units/save`,
        endpointGetAllProjects: `${endpointBackend}gci/projects/getall`,
        endpointGetAllUnitTypes: `${endpointBackend}gci/unit-types/getall`,
        endpointGetAllCardealPoints: `${endpointBackend}gci/cardeal-points/getall`,
        endpointGetAllSides: `${endpointBackend}gci/sides/getall`,
        endpointGetById: `${endpointBackend}gci/units/getById`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
        endpointGetIdentificationLevelsById: `${endpointBackend}gci/unit-types/getIdentificationLevelsById`,
        urlGoBack: `/gci/units/list`,
        pathView: `/gci/units/view`
    }

    const labels = {
        labelTitleAdd: "Nova Unidade",
        labelTitleEdit: "Editar Unidade",
        labelTitleView: 'Visualizar Unidade'
    }

    const getForm = (values, identificationFields) => {
        let form = {
            hiddenValues,
            fields: [
                !profileFilter.gci_company_id ? {
                    name: 'gci_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    handleChange: async (element, field, values) => {
                        const identificationFields = await getIdentificationFields(values.gci_unit_type_id)

                        values.gci_project_id = null;

                        let form = getForm(values, identificationFields);

                        form.fields[1].autoFocus = true;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 12
                } : {},
                {
                    name: 'gci_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                gci_company_id: values.gci_company_id
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'gci_unit_type_id',
                    type: 'select',
                    label: 'Tipo de Unidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllUnitTypes,
                        label: 'unit_type',
                        value: 'id',
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    handleChange: async (element, field, values) => {
                        const identificationFields = await getIdentificationFields(values.gci_unit_type_id)

                        values.block = null;
                        values.floor = null;
                        values.number = null;

                        let form = getForm(values, identificationFields);

                        form.fields[1].autoFocus = true;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                },
                ...getDynamicIdentificationFields(identificationFields),
                {
                    name: 'total_area',
                    type: 'decimal',
                    label: 'Metragem (m²)',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                },
                {
                    name: 'parking_number',
                    type: 'integer',
                    label: 'Vagas',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                },
                {
                    name: 'value',
                    type: 'decimal',
                    label: 'Valor Estimado',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                },
                {
                    name: 'gci_side_id',
                    type: 'select',
                    label: 'Lado',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllSides,
                        label: 'name',
                        value: 'id',
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 4
                },
                {
                    name: 'gci_cardeal_point_id',
                    type: 'select',
                    label: 'Ponto Cardeal',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCardealPoints,
                        label: 'name',
                        value: 'id',
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 4
                },
                {
                    name: 'bedrooms_number',
                    type: 'integer',
                    label: 'Número de Dormitórios',
                    validations: {
                        required: false
                    },
                    columnSize: 4
                },
                {
                    name: 'status',
                    type: 'select',
                    label: 'Status da Unidade',
                    options: [
                        {
                            label: 'Disponível',
                            value: 'available'
                        },
                        {
                            label: 'Reservada',
                            value: 'reserved'
                        },
                        {
                            label: 'Em Manutenção',
                            value: 'maintenance'
                        },
                        {
                            label: 'Indisponível',
                            value: 'unavailable'
                        },
                        {
                            label: 'Vendida',
                            value: 'sold'
                        }
                    ],
                    validations: {
                        required: false
                    },
                    readOnly: values.status == 'sold' && values.has_sale == '1',
                    columnSize: 12
                },
                values.status == 'reserved' ? {
                    name: 'formatted_reservation_limit',
                    type: 'text',
                    label: 'Data limite da reserva',
                    validations: {
                        required: false
                    },
                    readOnly: true
                } : {},
                {
                    name: 'observation',
                    type: 'textarea',
                    label: 'Observações',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels,
        }

        form.values = values;
        form.identificationFields = identificationFields;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            let identificationFields = await getIdentificationFields(values.gci_unit_type_id)

            const form = getForm(values, identificationFields);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    const getIdentificationFields = async (gci_unit_type_id) => {
        const defaults = {
            hasBlock: { value: false },
            hasFloor: { value: false },
            hasNumber: { value: false }
        };

        if (!gci_unit_type_id) return defaults;

        try {
            const identificationLevels = await Fetch.post(paths.endpointGetIdentificationLevelsById, { id: gci_unit_type_id });

            if (!identificationLevels) return defaults;

            return {
                hasBlock: identificationLevels.hasBlock ?? defaults.hasBlock,
                hasFloor: identificationLevels.hasFloor ?? defaults.hasFloor,
                hasNumber: identificationLevels.hasNumber ?? defaults.hasNumber
            };
        } catch (err) {
            return defaults;
        }
    }

    function getDynamicIdentificationFields(identificationFields = {}) {
        // Filtra apenas os campos ativos (value = true)
        const activeFields = Object.entries(identificationFields)
            .filter(([_, config]) => config?.value);

        if (activeFields.length === 0) return [];

        // Calcula o tamanho da coluna dinamicamente
        const columnSize = Math.floor(12 / activeFields.length);

        // Mapeia para os campos de formulário
        return activeFields.map(([key, config]) => ({
            name: key.replace(/^has/, '').toLowerCase(), // transforma "hasBlock" em "block"
            type: 'text',
            label: config.label,
            validations: { required: false },
            columnSize
        }));
    }


    return (
        <div>
            {formContent}
        </div>
    );
}

export default Form;
